module.exports = __webpack_public_path__ + "img/375_leuco_intro_img2.2627e35a.png";